// "The hedge book was replaced or reset wholesale" — the Hedging Grid's own reset fact.
//
// Fact-named after WHAT HAPPENED, not after the consumer that reacts (the same convention as
// Hg.HedgeMatrixChanged / Hg.HedgeMatrixStrikeContextChanged). Today the only subscriber is the
// HedgeMatrix CoPilot, which treats it exactly as its own reset button; anything else that caches a
// view of the book can subscribe without this contract changing.
//
// Owner ruling 2026-08-03: clearing hedges, loading defaults, rebuilding the grid and clearing the
// saved state "should have the same effect on the CoPilot as a reset button does". Those four are the
// publishers. Note what is NOT here: a single hedge edit, or exiting modification mode on one hedge —
// those are ordinary changes and belong to Hg.HedgeMatrixChanged.
//
// Declared as a CONSTANT rather than the folder's usual inline string literal because this topic has
// four publishers in three components: a typo in any one of them would silently publish to nowhere,
// and the symptom (a stale CoPilot after one particular button) is exactly the class of bug this
// message exists to fix.

export const HEDGE_BOOK_RESET_TOPIC = 'Hg.HedgeBookReset';

// Which action reset the book. Carried for the log/trace and for any future subscriber that needs to
// discriminate; the CoPilot deliberately treats all four identically.
export type HedgeBookResetReason =
    'hedges-cleared'
    | 'defaults-loaded'
    | 'grid-rebuilt'
    | 'saved-state-cleared';

export interface HedgeBookResetPayload {
    reason: HedgeBookResetReason;
}
